// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f16537cb","497":"f997a622","502":"ea77e7b4"}[chunkId] + ".chunk.js";
};